/**
 * Index Columns section: add single-variant products to cart
 * from .js-columns-atc buttons rendered when is_product is true.
 */
(function () {
  if (window.__columnsAtcInitialized) {
    return;
  }
  window.__columnsAtcInitialized = true;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.js-columns-atc');
    if (!btn) {
      return;
    }

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      return;
    }

    const originalText = btn.getAttribute('data-original-text');

    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) {
        const d = await res.json().catch(function () {
          return {};
        });
        throw new Error(d.description || 'Error');
      }

      await res.json();

      btn.disabled = false;

      const syncHeaderCartUi = function (cart) {
        const itemCount = cart.item_count;

        document
          .querySelectorAll('.cartCount, .CartCount, .cart-count, [data-cart-count]')
          .forEach(function (el) {
            el.textContent = String(itemCount);
            el.classList.toggle('hidden-count', itemCount < 1);
          });

        document.querySelectorAll('.cartCost').forEach(function (el) {
          if (itemCount === 0) {
            el.classList.add('hidden-count');
          } else {
            el.innerHTML = "(<span class='cart-count'>" + itemCount + '</span>)';
            el.classList.remove('hidden-count');
          }
        });
      };

      if (typeof window.updateCartCount === 'function') {
        window.updateCartCount();
      } else {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        syncHeaderCartUi(cart);
      }
    } catch (err) {
      btn.textContent = originalText;
      btn.disabled = false;
      console.error('Columns ATC error:', err);
    }
  });
})();
